module.exports = __webpack_public_path__ + "img/prize-03-pic.4cbf1a5c.png";